import script from "./diamondsMobileSearchForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./diamondsMobileSearchForm.vue?vue&type=script&setup=true&lang=ts"

import "./diamondsMobileSearchForm.vue?vue&type=style&index=0&id=0a87eaec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a87eaec"]])

export default __exports__